
import React from "react";
import { useState } from "react";
import MicroOut from "./MicroOut";
import LocationTabs from '../common/LocationTabs'

export default function MicroOutHome() {
	const [location, setLocation] = useState('Madison 1');
	const [user, setUser] = useState("");

	const handleLocationChange = (value) => {
		setLocation(value);
	};

	const handleReset = () => {
		setLocation("");
	};
	const handleUserChange = (newuser) => {
		setUser(newuser);
	};

	return (
		<div className="container">
			<div className="columns">
				<div className="column is-9">
					<span className="title">MicroManage OUT </span>
				</div>
			</div>
			<LocationTabs
				selectedLocation={location}
				onLocationChange={handleLocationChange}
				onUserChange={handleUserChange}
				isFromBatchManager={false}
			/>
			<MicroOut location={location} user={user} submitted={handleReset} />

		</div>
	);
}
